import { AutoAwesome, MoreVertOutlined } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  InputAdornment,
  TableCell,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomMenuItem from "../../../../component/Menu";
import { useNavigate } from "react-router-dom";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import BoxEditIco from "../../../../assets/icons/BoxEditIco";
import CommonButton from "../../../../component/Button";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import {
  StyledFlexColumnView,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import CreateNote from "./CreateNote";
// import AddEditKeyDeliverable from "./AddEditKeyDeliverable";
import moment from "moment";
import AddEditKeyDeliverable from "../../sow-enrichment-copy/components/AddEditKeyDeliverable";
import CommonTextField from "../../../../component/Input";
import Haley from "../../../../assets/images/Haley.png";
import CommonTable from "./CommonTable";

let dates = moment(new Date());
let today = dates.format("L");
const headerData = ["Key Deliverables", "Assumptions", ""];

const noteUpperData = [
  {
    title: "Client",
    component: "input",
    fontSize: "15px",
    value: "State of Minnesota",
    placeholderFontSize: "15px",
    placeholder: "Enter the name",
  },
  {
    title: "Date",
    component: "input",
    fontSize: "15px",
    value: moment(today).format("DD MMM YYYY"),
    placeholderFontSize: "15px",
    placeholder: "Enter the number",
  },
  {
    title: "Position",
    fontSize: "15px",
    value: "Project Atlantis",
    placeholderFontSize: "15px",
    placeholder: "Enter H1B Holder Company Name",
  },
  // {
  //   title: "Job ID",
  //   fontSize: "15px",
  //   value: "2742866",
  //   placeholderFontSize: "15px",
  //   placeholder: "Enter H1B Holder Company Name",
  // },
];

const typeData = [
  { name: "Standard", value: "Blank" },
  // { name: "Client Call", value: "Supplier Call" },
];

function KeyDeliverables({ handleClickVerify }) {
  const navigate = useNavigate();
  const [selectedRowData, setSelectedRowData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    deliverable: "",
    seniority: "",
    resourceCount: "",
    hrs: "",
  });
  const [openNoteDialog, setOpenNoteDialog] = useState(false);

  const [sortedData, setSortedData] = useState([
    {
      id: "10000",
      projectName:
        "Build a scalable SaaS app using Lightning, Apex, and Flow, integrating third-party tools and automation to streamline workflows.",
      assumption: "See Note",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Develop a scalable SaaS application using Lightning, Apex, and Flow for efficient user experiences. Integrate third-party tools to enhance functionality and optimize business processes.",
          title: "Notes",
          type: "Blank",
        },
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Automate workflows to improve efficiency and reduce manual effort.",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: "10001",
      projectName:
        "Leverage Salesforce Einstein AI for predictive insights, real-time dashboards, and workflow automation to enhance efficiency.",
      assumption: "See Note",
      notes: [
        {
          added_by: "Olivia Rhye",
          created_at: "2025-03-03T14:06:53.041Z",
          interaction: "Email",
          note: "Utilize Salesforce Einstein AI for predictive insights and data-driven decision-making.",
          title: "Notes",
          type: "Blank",
        },
      ],
    },
    {
      id: "10002",
      projectName:
        "Design an intuitive Lightning UI, implement RBAC & Salesforce Shield, and provide seamless onboarding with MyTrailhead.",
      assumption: "",
      notes: [],
    },
  ]);

  const [notesData, setNotesData] = useState({});
  const [noteList, setNoteList] = useState({
    open: false,
    laoding: false,
    noteId: "",
    type: "",
    note: "",
    created_at: "",
    job_history_reason: "",
    accecpting_less_more_candidates: "",
    locals_only: "",
    hybrid_days: "",
    project_scope: "",
    other_details: "",
    deadline_start: "",
    deadline_end: "",
  });
  const [notesTableList, setNotesTableList] = useState([]);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [seeNoteOpen, setSeeNoteOpen] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState([]);

  const handleSeeNote = (rowData) => {
    setSeeNoteOpen(true);
    setSelectedNotes(rowData.notes);
  };

  const handleCloseSeeNote = () => {
    setSeeNoteOpen(false);
    setSelectedNotes([]);
  };

  const handleRowCheckboxChange = (rowId) => {
    setSelectedRowData((prevSelected) => ({
      ...prevSelected,
      [rowId]: !prevSelected[rowId], // Toggling the checkbox state
    }));
  };

  const handleIconClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = (rowData) => {
    setSortedData((prevData) =>
      prevData.filter((item) => item.id !== rowData.id)
    );
  };

  const handleAddNote = () => {
    setOpenNoteDialog(true);
  };

  const handleCloseNoteDialog = () => {
    setOpenNoteDialog(false);
  };

  const menuData = [
    {
      title: "Add Note",
      image: <BoxEditIco />,
      onClick: () => handleAddNote(),
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      onClick: () => handleDelete(selectedRowData),
    },
  ];

  console.log(notesTableList, "notesTableList");
  const handleTableBodyData = (row, index) => {
    return (
      <>
        <TableCell
          sx={{
            color: row.color ? row.color : "#101828",
            fontWeight: 500,
            fontSize: "16px",
          }}
        >
          {row.projectName}
        </TableCell>
        <TableCell
          sx={{ color: "#7F56D9", fontWeight: 700, fontSize: "16px" }}
          onClick={() => handleSeeNote(row)}
        >
          {row.notes?.length ? "See Comments" : "-"}
        </TableCell>

        <TableCell align="right">
          <MoreVertOutlined
            style={{ cursor: "pointer" }}
            onClick={(e) => handleIconClick(e, row)}
          />
          <CustomMenuItem
            open={open}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
            menuData={menuData}
            boxShadow="0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
          />
        </TableCell>
      </>
    );
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowData(null); // Reset selected row data when closing dialog
    setFormData({
      deliverable: "",
      seniority: "",
      resourceCount: "",
      hrs: "",
    });
  };

  const handleClickAddKeyDeliverable = () => {
    setSelectedRowData(null);
    setOpenDialog(true);
  };

  const handleAddEditTeam = () => {
    if (selectedRowData) {
      // Editing existing deliverable
      setSortedData((prevData) =>
        prevData.map((item) =>
          item.id === selectedRowData.id
            ? { ...item, projectName: formData.deliverable }
            : item
        )
      );
    } else {
      // Adding a new deliverable
      const newDeliverable = {
        id: (sortedData.length + 100).toString(),
        projectName: formData.deliverable,
        color: "#0070F2",
        notes: [],
      };

      setSortedData((prevData) => [...prevData, newDeliverable]);
    }

    handleCloseDialog();
  };

  const handleEdit = (rowData) => {
    setFormData({
      deliverable: rowData.projectName,
    });
    setSelectedRowData(rowData); // Set selected row to track editing
    setOpenDialog(true);
  };

  const handleChangeText = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreateNote = async (values) => {
    setNoteList((prev) => ({ ...prev, loading: true }));

    let payload;
    if (values.type === "Blank") {
      payload = {
        note: values.note,
        interaction: "Email",
        added_by: "Olivia Rhye",
        type: values.type,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    } else {
      payload = {
        note: values.other_details,
        type: values.type,
        added_by: "username",
        hybrid_days: values.hybrid_days,
        deadline_start: values["Date_range"]?.["deadline_start"],
        deadline_end: values["Date_range"]?.["deadline_end"],
        job_history_type: values.job_history_type,
        job_history_reason: values.job_history_reason,
        accecpting_less_more_candidates: values.accecpting_less_more_candidates,
        locals_only: values.locals_only,
        project_scope: values.project_scope,
        created_at: new Date().toISOString(),
        title: "Notes",
      };
    }

    setTimeout(() => {
      setTimeout(() => {
        // setSortedData((prevData) =>
        //   prevData.map((item) =>
        //     item.id === noteList.noteId
        //       ? { ...item, notes: [...item.notes, payload] } // Append note to the correct project's notes array
        //       : item
        //   )
        // );
        setSortedData((prevData) =>
          prevData.map((item) =>
            item.id === selectedRowData.id
              ? { ...item, notes: [...item.notes, payload] }
              : item
          )
        );
        //   setNotesTableList((prevList) => {
        //     const indexToUpdate = prevList.findIndex(
        //       (item, index) => index === noteList.noteId
        //     );
        //     console.log(indexToUpdate, "indexToUpdate");

        //     if (indexToUpdate !== -1) {
        //       return prevList.map((item, index) =>
        //         index === indexToUpdate ? { ...item, ...payload } : item
        //       );
        //     } else {
        //       return [...prevList, payload];
        //     }
        //   });
      });

      setNotesTableListLoading(false);
      setSnackbarState({
        open: true,
        severity: "success",
        message: "Note added successfully",
      });

      handleCloseNoteDialog();
    }, 1000);
  };

  console.log(sortedData, "sortedData");

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <StyledFlexRowView style={{ gap: "30px" }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
              Key Deliverables
            </Typography>
            <CommonButton
              variant="contained"
              color="white"
              background="#7F56D9"
              fontWeight="700"
              value="Mark as verified"
              padding="8px 15px"
              onClick={handleClickVerify}
            />
          </StyledFlexRowView>

          <StyledFlexRowView>
            <CommonButton
              variant="outlined"
              color="#344054"
              SowKeyDeliverables
              border="#D0D5DD"
              fontWeight="700"
              value="Add Deliverable"
              padding="8px 15px"
              onClick={handleClickAddKeyDeliverable}
              boxShadow="0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            />
          </StyledFlexRowView>
        </StyledSpaceBetweenBox>
      </Grid2>

      <Grid2 size={12}>
        <CommonTable
          data={sortedData}
          columns={headerData}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleTableBodyData}
          withCheckbox={true}
        />
      </Grid2>

      <Grid2 item size={{ xs: 12 }}>
        <CommonTextField
          border={"0.5px solid #EAECF0"}
          padding={15}
          placeholder={"Ask Haley anything"}
          bgColor={"#F7F8F9"}
          startIcon={
            <InputAdornment position="start">
              <img src={Haley} />
            </InputAdornment>
          }
          endComponent={
            <CommonButton
              // onClick={() => setAi(!ai)}
              fontWeight={600}
              padding={"8px 25px"}
              value={"Ask Haley"}
              endIcon={<AutoAwesome />}
            />
          }
        />
      </Grid2>

      <AddEditKeyDeliverable
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleChangeText={handleChangeText}
        handleChange={handleChange}
        formData={formData}
        handleAddTeam={handleAddEditTeam}
        selectedRowData={selectedRowData}
      />

      <CreateNote
        openNoteDialog={openNoteDialog}
        handleCloseNoteDialog={handleCloseNoteDialog}
        // id={noteList.id}
        noteUpperData={noteUpperData}
        typeData={typeData}
        noteList={notesTableList}
        handleNoteSubmit={handleCreateNote}
      />

      {/* Notes Dialog */}
      <Dialog
        open={seeNoteOpen}
        onClose={handleCloseSeeNote}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontSize: "20px" }}>Notes</DialogTitle>
        <DialogContent>
          {selectedNotes.length > 0 ? (
            selectedNotes.map((note, index) => (
              <div key={index} style={{ marginBottom: "20px" }}>
                <StyledFlexColumnView>
                  <Typography variant="body1">
                    <strong>Added By:</strong> {note.added_by}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Date:</strong>{" "}
                    {moment(note.created_at).format("DD MMM YYYY")}
                  </Typography>
                  {/* <Typography variant="body2">
                  <strong style={{ color: "grey" }}>Type:</strong> {note.type}
                </Typography> */}
                  {/* <Typography variant="body2">
                  <strong>Interaction:</strong> {note.interaction}
                </Typography> */}
                  <Typography variant="body2">
                    <strong>Note:</strong>
                  </Typography>
                  <Typography sx={{ marginLeft: "20px" }}>
                    {note.note}
                  </Typography>
                </StyledFlexColumnView>
                <hr />
              </div>
            ))
          ) : (
            <Typography variant="body2">No notes available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSeeNote} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid2>
  );
}

export default KeyDeliverables;
